// openEHR BASE model — BMM package org.openehr.base.base_types.definitions
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import { String } from "../foundation_types/primitive_types.ts";
import { applyRmInit, type RmInit } from "../apply_rm_init.ts";

/**
 * Defines globally used constant values.
 *
 * `DATA_VALUE` reaches this class, not `Any`. Concrete descendants that
 * declare fields still apply init in their own constructors; this only
 * helps types with no further field initialisers.
 */
export class BASIC_DEFINITIONS {
  constructor(init?: RmInit) {
    applyRmInit(this, init);
  }
}

/**
 * Inheritance class to provide access to constants defined in other packages.
 */
export class OPENEHR_DEFINITIONS extends BASIC_DEFINITIONS {
}

/**
 * An enumeration of three values that may commonly occur in constraint models.
 *
 * Use as the type of any attribute within this model, which expresses constraint on some attribute in a class in a reference model. For example to indicate validity
 * of Date/Time fields.
 */
export class VALIDITY_KIND extends String {
}

/**
 * Status of a versioned artefact, as one of a number of possible values: uncontrolled, prerelease, release, build.
 */
export class VERSION_STATUS extends String {
}
